var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNok = function SvgNok(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 18,
    viewBox: "0 0 118 18",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 18L51.2058 4.5L66.7942 4.5L59 18Z",
    fill: "#651FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00006H40L42 7.00006H0V5.00006Z",
    fill: "#651FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118 5.00006H78L76 7.00006H118V5.00006Z",
    fill: "#651FFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nok.cc6794427b4cb0fc49292fd9d55eba9d.svg";